import { ReactNode } from "react";
import { type ROUTES_CONFIG } from "./routes-config";
import { RouterComponentMap, RoutesConfig } from "./types";
import { ROUTER_COMPONENTS_MAP } from "./routes-components";

export const retrieveRouteComponentsFromPath = <T extends RoutesConfig = typeof ROUTES_CONFIG>(
  path: string,
  map?: RouterComponentMap<T>
):
  | {
      pageComponent: ReactNode;
      useDefaultTitle?: boolean;
      customSidebarComponent?: ReactNode;
      indexRedirect?: string | ReactNode;
    }
  | undefined => {
  const resolvedMap = (map ?? ROUTER_COMPONENTS_MAP) as RouterComponentMap<T>;

  const segments = path.startsWith("/") ? path.slice(1).split("/") : path.split("/");
  const segment = segments[0];
  if (!segment) return undefined;

  const isLastSegment = segments.length === 1;
  const segmentPath = `/${segment}`;

  const entry = resolvedMap?.[segmentPath];
  if (!entry) return undefined;

  if (isLastSegment) {
    return {
      pageComponent: entry.pageComponent,
      useDefaultTitle: entry.useDefaultTitle,
      customSidebarComponent: entry.customSidebarComponent,
      indexRedirect: "indexRedirect" in entry ? entry.indexRedirect : undefined,
    };
  }

  // Check if entry has subRoutes before recursing
  if (!("subRoutes" in entry) || !entry.subRoutes) {
    return undefined;
  }

  segments.shift();
  const remainingPath = `/${segments.join("/")}`;
  return retrieveRouteComponentsFromPath(remainingPath, entry.subRoutes);
};
